import { useEffect } from "react";
import type { ViewState } from "../types";

export function ResultView({ setView }: { setView: (v: ViewState) => void }) {
  // Redirect to size-result — try-on result image is shown there
  useEffect(() => { setView("size-result"); }, []);
  return null;
}
